import { safeParseJSON } from "helpers";
import store from "redux/store";

const getIdentifier = (section) => {
  const { username, accountId, organizationId } = store.getState().auth;
  return `${section}_${username}_${organizationId}_${accountId}`;
};

const getRiskNotificationsIdentifier = () =>
  getIdentifier("risk_notifications");
const getRiskNotificationSummaryIdentifier = () =>
  `${getRiskNotificationsIdentifier()}-summary`;

const getInventoryIdentifier = () => getIdentifier("inventory");

const localStorageProvider = {
  setRiskNotificationListTimestamp: (timestampList) =>
    localStorage.setItem(
      getRiskNotificationsIdentifier(),
      JSON.stringify(timestampList)
    ),
  getRiskNotificationListTimestamp: () =>
    safeParseJSON(localStorage.getItem(getRiskNotificationsIdentifier()), {}),

  setDismissedRiskNotificationSummary: (v) =>
    localStorage.setItem(
      getRiskNotificationSummaryIdentifier(),
      JSON.stringify(v)
    ),
  getDismissedRiskNotificationSummary: () =>
    safeParseJSON(
      localStorage.getItem(getRiskNotificationSummaryIdentifier()),
      {}
    ),

  //do not store Inventory in cache anymore, since they configs became more diverse and complex
  removeInventoryReport: () =>
    localStorage.removeItem(getInventoryIdentifier()),
};

export default localStorageProvider;
